import { ActionReducerMap } from '@ngrx/store';
import { userReducer } from './user/reducer';
import { appReducer } from './app/reducer';
import { AppState } from './app.state';
import { mainReducer } from './main/main.reducer';
import { IMainState } from './main/main.model';
import { IUserConfigurationState } from './user-configuration/user-configuration.model';
import { userConfigurationReducer } from './user-configuration/user-configuration.reducer';
import { IAdvancedFilterStore } from './advanced-filter/advanced-filter.model';
import { advancedFilterReducer } from './advanced-filter/advanced-filter.reducer';
import { IUserSettingsState } from './settings/users/users.model';
import { userSettingsReducer } from './settings/users/users.reducer';
import { filterUserReducer, FilterUserState } from './filter/user/user.reducer';
import { filterFormReducer, FilterFormState } from './filter/form/form.reducer';
import { filterLogbookReducer, FilterLogbookState } from './filter/logbook/logbook.reducer';
import { filterStateReducer, FilterStateState } from './filter/state/state.reducer';
import { pageHeaderReducer } from './page-header/page-header.reducer';
import { IPageHeaderState } from './page-header/page-header.model';
import { IRolesState } from './settings/roles/roles.model';
import { roleReducer } from './settings/roles/roles.reducer';
import { IAuditTrailState } from './audit-trail/audit-trail.model';
import { auditTrailReducer } from './audit-trail/audit-trail.reducer';
import { rightReducer } from './settings/rights/rights.reducer';
import { IRightsState } from './settings/rights/rights.model';
import { clientSettingsReducer } from './settings/client/client.reducer';
import { IClientSettingsState } from './settings/client/client.model';
import { logbookScopesReducer } from './scopes/logbook-scopes/logbook-scopes.reducer';
import { IFormScopesState, ILogbookScopesState } from './scopes/scopes.model';
import { formScopesReducer } from './scopes/form-scopes/form-scopes.reducer';
import { IWorkflowState } from './settings/workflows/workflows.model';
import { workflowReducer } from './settings/workflows/workflows.reducer';
import { reasonReducer } from './reason/reason.reducer';
import { IReasonState } from './reason/reason.model';
import { logbookMasterDataReducer } from './settings/logbook-master-data/logbook-master-data.reducer';
import { formMasterDataReducer } from './settings/form-master-data/form-master-data.reducer';
import { ILogbookMasterDataState } from './settings/logbook-master-data/logbook-master-data.model';
import { IFormMasterDataState } from './settings/form-master-data/form-master-data.model';
import { ILogbooksState } from './logbooks/logbooks.model';
import { logbooksReducer } from './logbooks/logbooks.reducer';
import { logbookVersionsReducer } from './logbook-versions/logbook-versions.reducer';
import { ILogbookVersionState } from './logbook-versions/logbook-versions.model';
import { homeReducer } from './home/home.reducer';
import { IHomeState } from './home/home.model';
import { logsFormEntriesReducer } from './my-tasks/logs-form-entries/logs-form-entries.reducer';
import { ILogsFormEntriesState } from './my-tasks/logs-form-entries/logs-form-entries.model';
import { logbookTasksReducer } from './my-tasks/logbook-tasks/logbook-tasks.reducer';
import { ILogbookTasksState } from './my-tasks/logbook-tasks/logbook-tasks.model';
import { formTasksReducer } from './my-tasks/form-tasks/form-tasks.reducer';
import { IFormTasksState } from './my-tasks/form-tasks/form-tasks.model';
import { masterDataTasksReducer } from './my-tasks/master-data-tasks/master-data-tasks.reducer';
import { IMasterDataTasksState } from './my-tasks/master-data-tasks/master-data-tasks.model';
import { IFormEntriesState } from './reports/form-entries/form-entries.model';
import { formEntriesReducer } from './reports/form-entries/form-entries.reducer';
import { IMyReportsState } from './reports/my-reports/my-reports.model';
import { myReportsReducer } from './reports/my-reports/my-reports.reducer';
import { IFormTemplatesState } from './reports/form-templates/form-templates.model';
import { formTemplatesReducer } from './reports/form-templates/form-templates.reducer';
import { logbookTemplatesReducer } from './reports/logbook-templates/logbook-templates.reducer';
import { logsReportsReducer } from './reports/logs-reports/logs-reports.reducer';
import { ILogsReportsState } from './reports/logs-reports/logs-reports.model';
import { logbookStateReportReducer } from './reports/logbook-state-report/logbook-state-report.reducer';
import { ILogbookStateReportState } from './reports/logbook-state-report/logbook-state-report.model';
import { ILogbookTemplatesState } from './reports/logbook-templates/logbook-templates.model';
import { IForgotPinState } from './forgot-pin/forgot-pin.model';
import { forgotPinReducer } from './forgot-pin/forgot-pin.reducer';
import { checkInUsersReducer } from './check-in/check-in.reducer';
import { ICheckInUsersState } from './check-in/check-in.model';
import { IFormsState } from './forms/forms.model';
import { formsReducer } from './forms/forms.reducer';
import { statesReducer } from './settings/states/states.reducer';
import { IStateStates } from './settings/states/states.model';
import { IActivityTypeState } from './settings/activity-type/activity-type.model';
import { activityTypeReducer } from './settings/activity-type/activity-type.reducer';
import { IRuleState } from './settings/state-rule-and-automation/rules/rule.model';
import { ruleReducer } from './settings/state-rule-and-automation/rules/rule.reducer';
import { IAutomationState } from './settings/state-rule-and-automation/automations/automation.model';
import { automationReducer } from './settings/state-rule-and-automation/automations/automation.reducer';
import { IRuleTypeFilterState, ruleTypeFilterReducer } from './filter/rule-type/rule-type.reducer';
import {
  automationTypeFilterReducer,
  IAutomationTypeFilterState,
} from './filter/automation-type/automation-type.reducer';
import { stateRuleAndAutomationReducer } from './settings/state-rule-and-automation/state-rule-and-automation.reducer';
import { IStateRuleAndAutomationState } from './settings/state-rule-and-automation/state-rule-and-automation.model';
import { filterScopedLogbookReducer, IFilterScopedLogbookState } from './filter/scoped-logbook/scoped-logbook.reducer';
import { filterScopedFormReducer, IFilterScopedFormState } from './filter/scoped-form/scoped-form.reducer';
import { notificationGroupReducer } from './settings/notification-group/notification-group.reducer';
import { INotificationGroupDataState } from './settings/notification-group/notification-group.model';
import { sendNotificationGroupReducer } from './send-notification-group/send-notification-group.reducer';
import { ISendNotificationGroupState } from './send-notification-group/send-notification-group.model';
import { formioESignatureReducer } from './formio-e-signature/formio-e-signature.reducer';
import { IFormioESignatureState } from './formio-e-signature/formio-e-signature.model';
import { grantStateToChildrenReducer } from './grant-state-to-children/grant-state-to-children.reducer';
import { IGrantStateToChildrenState } from './grant-state-to-children/grant-state-to-children.model';
import { formioRoleCheckerReducer } from './formio-role-checker/formio-role-checker.reducer';
import { IFormioRoleCheckerState } from './formio-role-checker/formio-role-checker.model';
import { bulkMoveMobileLogbookReducer } from './bulk-move-mobile-logbooks/bulk-move-mobile-logbooks.reducer';
import { IBulkMoveMobileLogbookState } from './bulk-move-mobile-logbooks/bulk-move-mobile-logbooks.model';
import { formEntryConfigurableFieldsReducer } from './form-entry-configurable-fields/form-entry-configurable-fields.reducer';
import { IFormEntryConfigurableFieldsState } from './form-entry-configurable-fields/form-entry-configurable-fields.model';

export interface IFilter {
  userFilter: FilterUserState;
  formFilter: FilterFormState;
  logbookFilter: FilterLogbookState;
  stateFilter: FilterStateState;
  scopedLogbookFilter: IFilterScopedLogbookState;
  scopedFormFilter: IFilterScopedFormState;
  ruleTypeFilter: IRuleTypeFilterState;
  automationTypeFilter: IAutomationTypeFilterState;
}

export interface LogbookAppState extends AppState, IFilter {
  mainStore: IMainState;
  userConfigurationStore: IUserConfigurationState;
  advancedFilterStore: IAdvancedFilterStore;
  userSettingsStore: IUserSettingsState;
  pageHeaderStore: IPageHeaderState;
  roleStore: IRolesState;
  auditTrailStore: IAuditTrailState;
  rightStore: IRightsState;
  clientStore: IClientSettingsState;
  logbookScopeStore: ILogbookScopesState;
  formScopeStore: IFormScopesState;
  workflowStore: IWorkflowState;
  reasonStore: IReasonState;
  logbookMasterData: ILogbookMasterDataState;
  formMasterData: IFormMasterDataState;
  logbookSettingsStore: ILogbooksState;
  logbookVersionsStore: ILogbookVersionState;
  homeStore: IHomeState;
  logsFormEntriesStore: ILogsFormEntriesState;
  logbookTasksStore: ILogbookTasksState;
  formTasksStore: IFormTasksState;
  masterDataTasksStore: IMasterDataTasksState;
  formEntriesStore: IFormEntriesState;
  myReportsStore: IMyReportsState;
  formTemplatesStore: IFormTemplatesState;
  logbookTemplatesStore: ILogbookTemplatesState;
  logsReportsStore: ILogsReportsState;
  logbookStateReportStore: ILogbookStateReportState;
  forgotPinStore: IForgotPinState;
  checkInUsersStore: ICheckInUsersState;
  formSettingsStore: IFormsState;
  activityTypeStore: IActivityTypeState;
  statesStore: IStateStates;
  rulesStore: IRuleState;
  automationsStore: IAutomationState;
  stateRuleAndAutomationStore: IStateRuleAndAutomationState;
  notificationGroupStore: INotificationGroupDataState;
  sendNotificationGroupStore: ISendNotificationGroupState;
  formioESignatureStore: IFormioESignatureState;
  grantStateToChildrenStore: IGrantStateToChildrenState;
  formioRoleCheckerStore: IFormioRoleCheckerState;
  bulkMoveMobileLogbookStore: IBulkMoveMobileLogbookState;
  formEntryConfigurableFieldsStore: IFormEntryConfigurableFieldsState;
}

export const logbookAppReducer: ActionReducerMap<LogbookAppState> = {
  mainStore: mainReducer,
  user: userReducer,
  app: appReducer,
  userConfigurationStore: userConfigurationReducer,
  advancedFilterStore: advancedFilterReducer,
  userSettingsStore: userSettingsReducer,
  userFilter: filterUserReducer,
  formFilter: filterFormReducer,
  logbookFilter: filterLogbookReducer,
  stateFilter: filterStateReducer,
  scopedLogbookFilter: filterScopedLogbookReducer,
  scopedFormFilter: filterScopedFormReducer,
  pageHeaderStore: pageHeaderReducer,
  roleStore: roleReducer,
  auditTrailStore: auditTrailReducer,
  rightStore: rightReducer,
  clientStore: clientSettingsReducer,
  logbookScopeStore: logbookScopesReducer,
  formScopeStore: formScopesReducer,
  workflowStore: workflowReducer,
  reasonStore: reasonReducer,
  logbookMasterData: logbookMasterDataReducer,
  formMasterData: formMasterDataReducer,
  logbookSettingsStore: logbooksReducer,
  logbookVersionsStore: logbookVersionsReducer,
  homeStore: homeReducer,
  logsFormEntriesStore: logsFormEntriesReducer,
  logbookTasksStore: logbookTasksReducer,
  formTasksStore: formTasksReducer,
  masterDataTasksStore: masterDataTasksReducer,
  formEntriesStore: formEntriesReducer,
  myReportsStore: myReportsReducer,
  formTemplatesStore: formTemplatesReducer,
  logbookTemplatesStore: logbookTemplatesReducer,
  logsReportsStore: logsReportsReducer,
  logbookStateReportStore: logbookStateReportReducer,
  forgotPinStore: forgotPinReducer,
  checkInUsersStore: checkInUsersReducer,
  formSettingsStore: formsReducer,
  activityTypeStore: activityTypeReducer,
  statesStore: statesReducer,
  rulesStore: ruleReducer,
  automationsStore: automationReducer,
  ruleTypeFilter: ruleTypeFilterReducer,
  automationTypeFilter: automationTypeFilterReducer,
  stateRuleAndAutomationStore: stateRuleAndAutomationReducer,
  notificationGroupStore: notificationGroupReducer,
  sendNotificationGroupStore: sendNotificationGroupReducer,
  formioESignatureStore: formioESignatureReducer,
  grantStateToChildrenStore: grantStateToChildrenReducer,
  formioRoleCheckerStore: formioRoleCheckerReducer,
  bulkMoveMobileLogbookStore: bulkMoveMobileLogbookReducer,
  formEntryConfigurableFieldsStore: formEntryConfigurableFieldsReducer,
};
